import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { map } from 'rxjs/operators';
import { ICostUnitGroupOverview } from '../../models/cost-unit-group-overview.model';
import { ICostUnitGroupAssignmentsDialogLayout } from '../../models/layout/cost-unit-group-assignments-dialog-layout.model';
import { ICostUnitGroupDialogLayout } from '../../models/layout/cost-unit-group-dialog-layout.model';
import { ICostUnitGroupLayout } from '../../models/layout/cost-unit-group-layout.model';
import { CostUnitGroupFacade } from '../facades/master-data/cost-unit-group.facade';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class CostUnitGroupLayoutService {
    constructor(private myCostUnitGroupFacade: CostUnitGroupFacade,
                private mySharedDataFacade: SharedDataFacade) {
    }

    public getCostUnitGroupLayout(): ICostUnitGroupLayout {
        return {
            columns: [ 'name', 'assignments', 'edit-button' ],
        };
    }

    public getCostUnitGroupDialogLayout(): ICostUnitGroupDialogLayout {
        return {
            dialogFields: [
                { field: 'name', label: 'app.model.cost-unit-group.name.label', type: FieldType.text, required: true },
                {
                    field: 'parentCostUnitGroupId', label: 'app.model.cost-unit-group.parent.label', type: FieldType.select, withClearButton: true, selectData: {
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        options: this.mySharedDataFacade.fetchCostUnitGroups()
                            .pipe(map((groups: ICostUnitGroupOverview[]) => {
                                return this.flattenCostUnitGroups(groups);
                            })),
                    },
                },
            ],
        };
    }

    public getCostUnitAssignmentsDialogLayout(): ICostUnitGroupAssignmentsDialogLayout {
        return {
            columns: [ 'name', 'articleNr' ],
            selectFields: [
                {
                    field: 'selectedCostUnits',
                    label: 'app.model.cost-unit-group.assigned-cost-unit.label',
                    type: FieldType.multiselect,
                    selectData: {
                        displaySearch: true,
                        valueKey: 'id',
                        labelKeys: [ 'articleNr', 'name' ],
                        separator: ' - ',
                        options: this.myCostUnitGroupFacade.fetchCostUnits(),
                    },
                },
            ],
        };
    }

    public getContributionMarginLevelAssignmentsDialogLayout(): ICostUnitGroupAssignmentsDialogLayout {
        return {
            columns: [ 'name', 'order', 'delete-button' ],
            selectFields: [
                {
                    field: 'selectedContributionMarginLevelId',
                    label: 'app.model.cost-unit-group.assigned-contribution-margin-level.label',
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        valueKey: 'id',
                        labelKeys: [ 'name' ],
                        options: this.myCostUnitGroupFacade.fetchContributionMarginLevels(),
                    },
                },
            ],
        };
    }

    /**
     * Flattens a list of parent-costUnitGroups
     * @param groups
     * @private
     */
    private flattenCostUnitGroups(groups: ICostUnitGroupOverview[]): ICostUnitGroupOverview[] {
        let flatList: ICostUnitGroupOverview[] = [];

        for (const group of groups) {
            flatList.push(group);

            if (group.children && group.children.length > 0) {
                flatList = flatList.concat(this.flattenCostUnitGroups(group.children));
            }
        }
        return flatList;
    }
}
